import React, { useState, useEffect, useRef } from "react";
import styles from "./DeviceManager.module.scss";
import { Button, Card, Col, Form, Modal, Row, Spinner, Pagination, Container } from "react-bootstrap";
import { t } from "i18next";
import DataManager from "../../../General/DataManager";
import UserClass from "../../../General/LocalStorage/UserClass";
import Functions from "../../../General/Functions";

const DeviceManager = () => {
    const [applications, setApplications] = useState([]);
    const [selectedApplication, setSelectedApplication] = useState(null);
    const [showModal, setShowModal] = useState(true);
    const [devices, setDevices] = useState([]);
    const [itemsPagination, setItemsPagination] = useState(null);
    const [active, setActive] = useState(1);
    const [deviceUserSelected, setDeviceUserSelected] = useState("");
    const [showEditModal, setShowEditModal] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [DeviceName, setDeviceName] = useState("");
    const [selectedCompanies, setSelectedCompanies] = useState([]);
    const [showSpinner, setShowSpinner] = useState(true);
    const [searchValue, setSearchValue] = useState("");
    const [filter, setFilter] = useState([]);
    const [startIndex, setStartIndex] = useState(null);
    const [endIndex, setEndIndex] = useState(null);
    const [currentPage, setCurrentPage] = useState(null);

    useEffect(() => {
        const instance = UserClass.getInstance();
        const userToken = instance.getTokenUser();
        getDeviceApplications(userToken);
    }, []);

    const getDeviceApplications = (token) => {
        DataManager.getApplicationList(token).then((response) => {
            const temp = response?.result?.results || [];
            if (response?.result) {
                const instance = UserClass.getInstance();
                const userInfo = instance.getUser();
                setCompanies(userInfo.companies || []);

                if (userInfo?.role === "SYSADMIN" || userInfo?.role === "DEVICE_MANAGER") {
                    temp.push("TUTTE");
                }
                setApplications(temp);
            } else {
                Functions.alertMsg(response?.msgError || t("msgErrorGeneral"));
            }
        });
    };

    const setApplication = (e) => {
        const app = applications[e.target.selectedIndex - 1];
        setSearchValue("");
        if (app) {
            setTimeout(() => {
                setSelectedApplication(app);
                getListDevices(app);
                setShowModal(false);
            }, 300);
        }
        else {
            setSelectedApplication(null);
            setShowModal(true);

        }
    };

    const getListDevices = (app,name) => {
        const instance = UserClass.getInstance();
        const userToken = instance.getTokenUser();
        if (app === "TUTTE") app = "";

        DataManager.getDevicesList(userToken, app,name).then((response) => {
            if (response?.result) {
                const data = response.result;
                setDevices(data.results);
                setItemsPagination(data.pagination);
                setStartIndex((data.pagination.page - 1) * data.pagination.limit + 1);
                setEndIndex(Math.min(data.pagination.page * data.pagination.limit, data.pagination.total));
                setCurrentPage(data.pagination.page);
            } else {
                Functions.alertMsg(response?.msgError || t("msgErrorGeneral"));
            }
        });
    };

    const getListDevicesPagination = (number) => {
        const app = selectedApplication === "TUTTE" ? "" : selectedApplication;
        const instance = UserClass.getInstance();
        const token = instance.getTokenUser();

        DataManager.getDevicesListPagination(token, app, number, 10, true).then((response) => {
            if (response?.result) {
                const data = response.result;
                setDevices(data.results);
                setItemsPagination(data.pagination);
                setStartIndex((data.pagination.page - 1) * data.pagination.limit + 1);
                setEndIndex(Math.min(data.pagination.page * data.pagination.limit, data.pagination.total));
                setCurrentPage(data.pagination.page);
                setActive(number);
            } else {
                Functions.alertMsg(response?.msgError || t("msgErrorGeneral"));
            }
        });
    };

    const renderColumnTable = () => (
        <thead>
            <tr>
                <th>{t("device_name")}</th>
                <th>{t("udid")}</th>
                <th>{t("application")}</th>
                <th>{t("company")}</th>
                <th>{t("actions")}</th>
            </tr>
        </thead>
    );

    const handleEdit = (item) => {
        setShowEditModal(true);
        setDeviceUserSelected(item);
        setSelectedCompanies(item.companies);
        setDeviceName(item.name);
    };

    const renderActionSection = (item) => (
        <td key={item.id}>
            <div className="text-center">
                <Button
                    variant="outline-primary"
                    size="sm"
                    className="rounded-pill"
                    onClick={() => handleEdit(item)}
                >
                    <i className="fa fa-edit me-2"></i>
                    {t("edit")}
                </Button>
            </div>
        </td>
    );

    const renderListDevices = () => {
        //const data = searchValue !== "" ? filter : devices;
        const data = devices;

        return (
            <tbody>
                {data.map((item, idx) => (
                    <tr key={idx}>
                        <td>{item.name}</td>
                        <td>{item.udid}</td>
                        <td>{item.application}</td>
                        <td>
                            {item.companies.map((companyName, index) => (
                                <Form.Check
                                    key={index}
                                    type="checkbox"
                                    label={companyName}
                                    checked
                                    disabled
                                />
                            ))}
                        </td>
                        {renderActionSection(item)}
                    </tr>
                ))}
            </tbody>
        );
    };

    const renderPagination = () => {
        if (itemsPagination && searchValue === "") {
            const totalItems = itemsPagination.total;
            const totalPages = Math.ceil(totalItems / itemsPagination.limit);
            const items = [];

            for (let number = 1; number <= totalPages; number++) {
                items.push(
                    <Pagination.Item
                        key={number}
                        active={number === active}
                        onClick={() => getListDevicesPagination(number)}
                    >
                        {number}
                    </Pagination.Item>
                );
            }

            return (
                <div className={`${styles.paginationWrapper} mt-4`}>
                    <div className="small text-muted mb-2 text-center">
                        {t("results")} {startIndex} {t("to")} {endIndex} {t("of")} {itemsPagination?.total}
                    </div>
                    <div className={styles.paginationScroll}>
                        <Pagination className="justify-content-center m-0">
                            <Pagination.First
                                onClick={() => getListDevicesPagination(1)}
                                disabled={currentPage === 1}
                            />
                            <Pagination.Prev
                                onClick={() => getListDevicesPagination(currentPage - 1)}
                                disabled={currentPage === 1}
                            />
                            {items}
                            <Pagination.Next
                                onClick={() => getListDevicesPagination(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            />
                            <Pagination.Last
                                onClick={() => getListDevicesPagination(totalPages)}
                                disabled={currentPage === totalPages}
                            />
                        </Pagination>
                    </div>
                </div>
            );
        }
        return null;
    };


    const handleDeviceUpdate = () => {
        if (deviceUserSelected.application === "CHECKIN" && selectedCompanies.length > 1) {
            Functions.alertMsg(t("onlyone"));
            return;
        }
        if (selectedCompanies.length === 0) {
            Functions.alertMsg(t("selectonecom"));
            return;
        }
        if (DeviceName === "") {
            Functions.alertMsg(t("devicenameerror"));
            return;
        }

        setShowSpinner(false);
        const instance = UserClass.getInstance();
        const token = instance.getTokenUser();
        const data = { name: DeviceName, companies: selectedCompanies, id: deviceUserSelected.id };

        DataManager.updateDeviceDetails(token, data).then((response) => {
            if (response?.result) {
                Functions.alertMsgSuccess(t("save_success"));
                getListDevicesPagination(currentPage);
                setShowSpinner(true);
                handleClose();
            } else {
                Functions.alertMsg(response?.msgError || t("msgErrorGeneral"));
            }
        });
    };

    const handleClose = () => setShowEditModal(false);
    const handleDeviceNameChange = (event) => setDeviceName(event.target.value);

    /*const handleSearch = (e) => {
        setSearchValue(e.target.value);
        const filteredRows = devices.filter(
            (row) =>
                row.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
                row.udid.toLowerCase().includes(e.target.value.toLowerCase())
        );
        setFilter(e.target.value.length < 1 ? [] : filteredRows);
    };*/
    const searchTimeout = useRef(null);

    const handleSearch2 = (e) => {
        const newValue = e.target.value;
        setSearchValue(newValue);

        clearTimeout(searchTimeout.current);

        searchTimeout.current = setTimeout(() => {
            if (newValue.length > 2) {
                getListDevices(selectedApplication, newValue);
            } else if (newValue === "") {
                getListDevices(selectedApplication);
            }
        }, 300);
    };

    const handleSelectedCompany = (event) => {
        if (deviceUserSelected.application === "CHECKIN") {
            setSelectedCompanies([event.target.value]);
        } else {
            const { value, checked } = event.target;
            setSelectedCompanies((prev) =>
                checked ? [...prev, value] : prev.filter((company) => company !== value)
            );
        }
    };

    return (
        <div className={styles.DeviceManager}>
            <Container fluid="md">
                <Card className="p-4 shadow-sm">
                    <Row className="mb-3">
                        <Col xs={12} md={6}>
                            <Form.Label className="fw-semibold">{t("selectapplication")}</Form.Label>
                            <Form.Select size="lg" onChange={setApplication}>
                                <option key="value_null" value={null}>-- {t("select")} --</option>
                                {applications?.map((item, idx) => (
                                    <option key={idx}>{item}</option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>

                    {!showModal && (
                        <>
                            <Row className="mb-4">
                                <Col xs={12} md={6}>
                                    <Form.Label className="fw-semibold">{t("search")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="search"
                                        value={searchValue}
                                        //onChange={handleSearch}
                                        onChange={handleSearch2}
                                        placeholder={"🔍" + t('search_by_name_udid')}
                                    />
                                </Col>
                            </Row>

                            <div className="table-responsive">
                                <table className="table align-middle table-striped table-hover">
                                    {renderColumnTable()}
                                    {renderListDevices()}
                                </table>
                            </div>

                            <div className="mt-3">{renderPagination()}</div>
                        </>
                    )}
                </Card>
            </Container>

            <Modal show={showEditModal} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("update_device")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>{t("device_name")}</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder={t("device_name")}
                                value={DeviceName}
                                onChange={handleDeviceNameChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{t("company")}</Form.Label>
                            {companies?.map((companyName, index) => (
                                <Form.Check
                                    key={index}
                                    type="checkbox"
                                    id={companyName}
                                    label={companyName}
                                    value={companyName}
                                    checked={selectedCompanies?.includes(companyName)}
                                    onChange={handleSelectedCompany}
                                />
                            ))}
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Spinner hidden={showSpinner} animation="border" size="sm" />
                    <Button variant="secondary" onClick={handleClose}>
                        {t("close")}
                    </Button>
                    <Button variant="primary" onClick={handleDeviceUpdate}>
                        {t("apply")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DeviceManager;
